import { render, staticRenderFns } from "./DocumentCheckTable.vue?vue&type=template&id=0647e4ec"
import script from "./DocumentCheckTable.vue?vue&type=script&lang=ts"
export * from "./DocumentCheckTable.vue?vue&type=script&lang=ts"
import style0 from "./DocumentCheckTable.vue?vue&type=style&index=0&id=0647e4ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports